// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

import './TitleSection.scss';

interface TitleSectionProps {
    children: ReactNode;
    className?: string;
    extraAction?: ReactNode;
}

export const TitleSection = ({ className = '', children, extraAction }: TitleSectionProps): ReactElement => (
    <div className={classList('title-section', className)}>
        <span className="title-section__children children__title">{children}</span>
        {!!extraAction && <span className="title-section__children children__extra-action">{extraAction}</span>}
    </div>
);
